import React from 'react';

import { HighlightBanner, ImageBanner, ImageBannerImage, ImageBannerContent, Button } from '@hpi-sox/hpstellar-core';

import { withError } from '../../shared/components/error-boundary';
import { getImageBannerContent, getHighlightBannerContent } from '../../utility/setHtml';
import LCPPrefetch, { getPrefetchImageArray } from '../../shared/components/lcp-prefetch';

const EMPTY_OBJ = {};

export default withError(({ className, banner, loading, prefetch, prefetchMinWidth = 1024 }) => {
    if (!banner || (Array.isArray(banner) && banner.length < 1)) {
        return null;
    }

    if (banner.highlightBanner) {
        return <HighlightBanner className={className} {...getHighlightBannerContent(banner.highlightBanner)} />;
    }
    const { image = EMPTY_OBJ, cta = EMPTY_OBJ, gtmActions, textTheme: theme, variation, ...restProps } = banner[0];
    const { alt, url = EMPTY_OBJ, ...restImg } = image;
    const { desktop: src, mobile: srcMobile } = url;
    const { props: ctaProps = EMPTY_OBJ, text: ctaText, ariaLabel } = cta || EMPTY_OBJ;

    // TODO: will need to update and reflect how they implement the multiple cta JSON output on the JSON tool
    const button = ctaProps && (
        <Button {...ctaProps} ariaLabel={ariaLabel} gtmActions={gtmActions}>
            {ctaText}
        </Button>
    );

    return (
        <>
            {prefetch && (
                <LCPPrefetch
                    images={getPrefetchImageArray(`${src}-${srcMobile}`, [
                        { href: src, minWidth: prefetchMinWidth },
                        { href: srcMobile },
                    ])}
                    matchOne={true}
                />
            )}
            <ImageBanner className={className} theme={theme} variation={variation}>
                {(src || srcMobile) && (
                    <ImageBannerImage src={src} srcMobile={srcMobile} alt={alt} loading={loading} {...restImg} />
                )}

                <ImageBannerContent buttonGroup={[button]} {...getImageBannerContent(restProps)} />
            </ImageBanner>
        </>
    );
});
